import { atom } from 'recoil';
import { ICsvHeaderTableState, ICsvTableState } from './types';

const initialState: ICsvHeaderTableState[] = [];
const metricsInitialState: string[] = [];
const csvInitialState: ICsvTableState[][] = [];
const csvHeadInitialState: ICsvHeaderTableState[] = [];
const filteredCsvState: ICsvTableState[][] = [];

export const CsvHeaderTableState = atom<ICsvHeaderTableState[]>({
  key: 'csv-table-header',
  default: initialState,
});

export const CsvMetricsTableState = atom<string[]>({
  key: 'csv-head',
  default: metricsInitialState,
});

export const CsvDataTableState = atom<ICsvTableState[][]>({
  key: 'csv-table-data',
  default: csvInitialState,
});

export const CsvHeadTableState = atom<ICsvHeaderTableState[]>({
  key: 'csv-head-table-data',
  default: csvHeadInitialState,
});

export const filteredCsvTableState = atom<ICsvTableState[][]>({
  key: 'filter-csv-table',
  default: filteredCsvState,
});

export const primaryKeyCsvTableState = atom<string>({
  key: 'primary-key-csv-table',
  default: '',
});

export const csvTableTypeState = atom<string>({
  key: 'csv-table-type',
  default: '',
});

export const csvTimeBasedKeyState = atom<string>({
  key: 'csv-time-based-type',
  default: '',
});

export const csvUniqueKeys = atom<string[]>({
  key: 'unique-csv-keys',
  default: [],
});

export const csvTimeFormatState = atom<string>({
  key: 'csv-time-format',
  default: '',
});
